import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../LoadingSpinner';
import { Link, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import "./Weather.css";

const ContactForm = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate data fetching
    setTimeout(() => {
      setIsLoading(false); // Stop spinner after fetching data
    }, 1000);
  }, []);

  const handleRefresh = () => {
  window.location.reload();
};

   return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div>
      {isLoading ? (
  <LoadingSpinner />
) : (

  <iframe
  src={`https://www.spcommunity.org.za/weather-forecast-app?t=${Date.now()}`}
  style={{ width: "100%", height: "100vh", border: "none", overflow: "auto" }}
  title="Contact Form"
  onLoad={() => setIsLoading(false)}
></iframe>



      
       )}

       {isLoading && <LoadingSpinner />}
    </div>
  ); 
  
};

export default ContactForm;
